var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaPluginAuthComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Complete / ring + check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.799 12.201C46.548 6.94999 39.4261 4 32 4C24.5739 4 17.452 6.94999 12.201 12.201C6.94999 17.452 4 24.5739 4 32C4 39.4261 6.94999 46.548 12.201 51.799C17.452 57.05 24.5739 60 32 60C39.4261 60 46.548 57.05 51.799 51.799C57.05 46.548 60 39.4261 60 32C60 24.5739 57.05 17.452 51.799 12.201Z",
    stroke: "#50B786",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6667 32.6667L28 42L45.3333 24.6667",
    stroke: "#50B786",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaPluginAuthComplete);
export default __webpack_public_path__ + "static/media/figma-plugin-auth-complete.3508b64b5309d4f94e86e8a9fd87b3b3.svg";
export { ForwardRef as ReactComponent };